import(/* webpackMode: "eager" */ "/vercel/path0/app/error.jsx");
